import type { EditorCanvas } from "replo-utils/lib/misc/canvas";

import React from "react";

import { CANVAS_DATA } from "@/features/canvas/canvas-constants";
import { useViewportStore } from "@/features/react-editor/store/viewportStore";
import IconButton from "@replo/design-system/components/button/IconButton";
import { MonitorSmartphone } from "lucide-react";

interface ResponsiveControlsProps {
  variant?: "primary" | "secondary" | "tertiary" | "danger" | "link";
}

function ResponsiveControls({ variant = "tertiary" }: ResponsiveControlsProps) {
  const { currentViewport, setCurrentViewport } = useViewportStore();

  const handleViewportToggle = () => {
    const nextViewport: EditorCanvas =
      currentViewport === "mobile" ? "desktop" : "mobile";
    setCurrentViewport(nextViewport);
  };

  const getTooltipText = () => {
    const nextViewport: EditorCanvas =
      currentViewport === "mobile" ? "desktop" : "mobile";
    const nextWidth = CANVAS_DATA[nextViewport].defaultFrameWidth;
    return `Switch to ${nextViewport} (${nextWidth}px)`;
  };

  return (
    <div className="flex items-center gap-2">
      <IconButton
        variant={variant}
        size="base"
        icon={<MonitorSmartphone size={16} />}
        onClick={handleViewportToggle}
        tooltipText={getTooltipText()}
      />
    </div>
  );
}

export default ResponsiveControls;
